import React from 'react';
import './TextareaField.scss';

export interface InputProp {
  label: string;
  inputContainer: string;
  inputStyle: string;
  placeholder?: string;
  value?: string;
  name: string;
  onChange: any;
  minHeight?: string;
}

const TextareaField = (props: InputProp) => {
  return (
    <div className={props.inputContainer}>
      <label className="label">{props.label}</label>
      <textarea
        name={props.name}
        onChange={props.onChange}
        value={props.value}
        placeholder={props.placeholder}
        className={props.inputStyle}
        rows={50}
        style={{ minHeight: props?.minHeight ?? 'auto' }}
      />
    </div>
  );
};

export default TextareaField;
